import styled from 'styled-components'

export const StoryContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: gray;
`
export const QuestionTextContainer = styled.div``
